import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default function () {
	gsap.registerPlugin(ScrollTrigger);

	gsap.from(".anima-comming-soon > *", {
		y: 50,
		opacity: 0,
		duration: 0.8,
		stagger: 0.2
	});
}